// removed by extract-text-webpack-plugin
module.exports = {"mobile":"480","tablet":"768","tablet-landscape":"1024","tabletLandscape":"1024","desktop":"1280","wide":"1600","fullhd":"1920"};


//////////////////
// WEBPACK FOOTER
// ./app/assets/styles/_breakpoints.scss
// module id = NJKw
// module chunks = 2